import {ArchiveRecord} from 'archive/ArchiveConstants';
import {assert} from 'Asserts';
import {TagSchema} from 'constants/RegistryConstants';
import {FileLinkSchemaTag, SchemaTag, Tag} from 'folder-items/FileConstants';
import {SchemaField} from 'schemas/fields/SchemaFieldConstants';

import {AuthorGraphQL} from '../../../graphql-fragments/parties/__generated/AuthorGraphQL';

export interface ChildEntityDataForTab {
  id: string;
  archiveRecord: ArchiveRecord | null;
  authors: Array<AuthorGraphQL>;
  createdAt: string;
  name: string;
  tags: Array<Tag>;
}

export interface ChildEntityLinkConfig {
  childEntitySchemaId: string;
  childSchemaLinkField: SchemaField;
}

export interface ChildEntityAwareTagSchema extends TagSchema {
  childEntityLinkConfigs: Array<ChildEntityLinkConfig>;
}

export function isParentLinkSchemaField(field: SchemaField): boolean {
  return field.isParentLink;
}

export function getParentLinkFileId(schemaTag: SchemaTag): string | null {
  assert(
    isParentLinkSchemaField(schemaTag.tagSchemaField),
    'getParentLinkFileId expected parent link schema tag'
  );
  const fileLinkTag = schemaTag as FileLinkSchemaTag;
  assert(
    fileLinkTag.targetFiles.length <= 1,
    'Expected at most 1 target file for a parent link schema tag, which cannot be multi'
  );
  return fileLinkTag.targetFiles.length ? fileLinkTag.targetFiles[0].id : null;
}

export function makeTagSchemaChildEntityAware(schema: TagSchema): ChildEntityAwareTagSchema {
  return {
    ...schema,
    childEntityLinkConfigs: [],
  };
}
